import imagesLoaded from "imagesloaded";

export default PreloadImages = () => {

  const preloadImages = () => {
    return new Promise((resolve, reject) => {
      var imgLoad = imagesLoaded(
        document.querySelectorAll("img"),
        {
          background: true,
        },
        resolve
      );
    });
  };
  preloadImages().then(() => {
    const bodyEl = document.getElementsByTagName("body")[0];
    var event = new CustomEvent("pageloaded");
    bodyEl.classList.remove("loading");
    document.dispatchEvent(event);
  });

}
